import type { JSX, Dispatch, SetStateAction } from "react";

import { useDispatch } from "react-redux";

import { showSuccessToast, showErrorToast } from "app/actions/toast_actions";
import type { IDashboardExtended } from "app/components/dashboard/services/IDashboard";
import { useSharedUsersListContext } from "app/pages/dashboard/hooks/useSharedUsersList";
import { SHARED_DASHBOARDS_END_POINT } from "app/pages/dashboard/ShareDashboardService";
import { SharedDashboardModal } from "app/pages/dashboard/SharedDashboardModal/SharedDashboardModal";
import {
    getModalText,
    onSharingSubmit,
    resolveSharingStateToShareModalFormat,
} from "app/pages/dashboard/SharedDashboardModal/utils";

interface ISharedDashboardModalContainerProps {
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    currentDashboard: IDashboardExtended;
    setCurrentDashboard: Dispatch<SetStateAction<IDashboardExtended | null>>;
    isSharingDashboard: boolean;
    setIsSharingDashboard: Dispatch<SetStateAction<boolean>>;
}

export const SharedDashboardModalContainer = ({
    setIsOpen,
    currentDashboard,
    setCurrentDashboard,
    isSharingDashboard,
    setIsSharingDashboard,
}: ISharedDashboardModalContainerProps): JSX.Element => {
    const dispatch = useDispatch();
    const [{ users }] = useSharedUsersListContext();

    const dispatchSuccessToast = (text: string): void => {
        dispatch(showSuccessToast(text));
    };

    const dispatchErrorToast = (text: string): void => {
        dispatch(showErrorToast(text));
    };

    const shareEndPoint = `${SHARED_DASHBOARDS_END_POINT}/${currentDashboard?.id}`;

    const onShareSubmit = onSharingSubmit(
        currentDashboard,
        setCurrentDashboard,
        dispatchSuccessToast,
        dispatchErrorToast,
        setIsSharingDashboard,
        shareEndPoint,
    );

    return (
        <SharedDashboardModal
            onSubmit={onShareSubmit}
            modalText={getModalText(currentDashboard)}
            sharedWithUsers={currentDashboard.sharedWithUsers}
            sharedWithInvitations={currentDashboard.sharedWithInvitations}
            initialSharingState={resolveSharingStateToShareModalFormat(currentDashboard)}
            setIsOpen={setIsOpen}
            isSharingDashboard={isSharingDashboard}
            users={users}
        />
    );
};
